export var convertToSelectValues = function (data) {
    if (!data)
        return null;
    return data.map(function (el) {
        var _a, _b, _c, _d, _e, _f;
        var obj = el;
        var fullName = !!((_a = obj.firstName) === null || _a === void 0 ? void 0 : _a.length) && !!((_b = obj.lastName) === null || _b === void 0 ? void 0 : _b.length)
            ? "".concat(obj.lastName, " ").concat(obj.firstName.charAt(0), ".").concat(((_c = obj.middleName) === null || _c === void 0 ? void 0 : _c.length) ? obj.middleName.charAt(0) + '.' : '')
            : '';
        return {
            label: (_f = (_e = (_d = obj.name) !== null && _d !== void 0 ? _d : obj.title) !== null && _e !== void 0 ? _e : fullName) !== null && _f !== void 0 ? _f : obj.username,
            value: obj.id,
        };
    });
};
